import {
  SETTINGS_EMPLOYEE_SETTINGS_SECURITY_LEVELS,
  SETTINGS_ROUTES,
} from '@/views/settings/core/settingsRoutes.ts';

/**
 * Page actions sit beside FilterButton sm and the visibility dropdown (h-9).
 * The default primary button is h-11 and grows on hover.
 */
export const EMPLOYEE_SETTINGS_TOOLBAR_ACTION_CLASS = '!h-9 !min-h-0 !px-3 !py-0 hover:!scale-100';

/** Inner employee-settings screens. Pending is the shared contract/project gap report. */
export const EMPLOYEE_SETTINGS_TAB_ITEMS = [
  {
    id: 'agreements',
    path: SETTINGS_ROUTES.employeeSettings.tabs.agreements,
    i18nKey: 'employee_settings.tabs.agreements',
    testId: 'settings-employee-settings-tab-agreements',
  },
  {
    id: 'contracts',
    path: SETTINGS_ROUTES.employeeSettings.tabs.contracts,
    i18nKey: 'employee_settings.tabs.contracts',
    testId: 'settings-employee-settings-tab-contracts',
  },
  {
    id: 'projects',
    path: SETTINGS_ROUTES.employeeSettings.tabs.projects,
    i18nKey: 'employee_settings.tabs.projects',
    testId: 'settings-employee-settings-tab-projects',
  },
  {
    id: 'pending',
    path: SETTINGS_ROUTES.employeeSettings.tabs.pending,
    i18nKey: 'employee_settings.tabs.pending',
    testId: 'settings-employee-settings-tab-pending',
  },
];

/**
 * Routing and access for Settings → Employee settings (agreements, contracts, pending gaps, projects).
 */
export const EMPLOYEE_SETTINGS_CONFIG = {
  routing: {
    basePath: SETTINGS_ROUTES.employeeSettings.basePath,
    securityLevel: [...SETTINGS_EMPLOYEE_SETTINGS_SECURITY_LEVELS],
    tabs: SETTINGS_ROUTES.employeeSettings.tabs,
  },
};
